var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my_container tac title"},[_c('div',{staticClass:"first"},[_vm._v(_vm._s(_vm.title))]),_c('br'),_c('div',{staticClass:"second"},[_vm._v(_vm._s(_vm.enTitle))])])}
var staticRenderFns = []

export { render, staticRenderFns }